import * as React from 'react'

import Stack from '@mui/material/Stack'

import { I18n, useTranslation } from 'components/hooks/use-translation'
import PathSyllabus from 'components/atomic/organisms/syllabus/path'
import Text from 'components/atomic/atoms/text'

interface SyllabusProps {
    pathId: string
}

const Syllabus = (props: SyllabusProps) => {
    const { t }: I18n = useTranslation()

    return (
        <Stack spacing={1}>
            <Text variant="h4">{t('path:syllabusEnrolled.title')}</Text>
            <PathSyllabus pathId={props.pathId} />
        </Stack>
    )
}

export default Syllabus
